
import store from "../store"

import {
    searchFetch
} from "./search.js"

import {
    setWorldState,
} from "./index"



export const endSpeech = (result, searchType) => {

    return function (dispatch) {

        // dispatch( searchFetch(result) )

        return {
            type: "SPEECH_END",
            result: result,
            searchType: searchType,
        }
    }
    
}

export const resetSpeech = () => {

    let sphere = document.getElementById("small-sphere")
    sphere.emit("sphereclose")

    return {
        type: "MIC_RESET",
    }
}

export const setInterimResult = (result) => {

    return {
        type: "SET_INTERIM_SPEECH",
        result: result
    }
}

export const setFinalResult = (result) => {

    return function (dispatch) {

        dispatch( searchFetch(result) )

        return {
            type: "SET_FINAL_SPEECH",
            result: result
        }
    }
}

export const clearResult = () => {

    return {
        type: "CLEAR_RESULT",
    }
}


// const onnomatch = () => {
//     console.log("DEBUG: Failed To Math Recognition Audio");
// }

const onstart = () => {
    console.log("DEBUG: Speech Recognition Activated");

    return {
        type: "SPEECH_STARTED",
    }
}

const onresult = (e) => {
    console.log("DEBUG: Result", e)

    var interrimResult = "";
    for (var i = e.resultIndex; i < e.results.length; ++i) {

        if (!e.results[i].isFinal) {
            interrimResult += e.results[i][0].transcript
            console.log(interrimResult)

            store.dispatch( setInterimResult(interrimResult) )

        } else {
            console.log("DEBUG: Finnished", e.results[i][0].transcript)

            store.dispatch( setFinalResult(e.results[i][0].transcript) )
        }

    }
}

const onerror = (e) => {
    console.log("DEBUG: Speech Recognition Error", e)

    return {
        type: "SPEECH_ERROR",
        event: e,
    }
}

const onend = (e) => {
    
    return function (dispatch, getState) {
        const state = getState()

        console.log("DEBUG: Speech Recognition Endeds")
    
        if (state.microphone.text.length === 0) {
            console.log("Reseting Speech")
    
            dispatch(resetSpeech())
            return
        }
    
        console.log("Ending Speech")
        dispatch(endSpeech(state.microphone.text, state.globalState.searchType))
    }

}

const recognition = new window.webkitSpeechRecognition()

if ( !('webkitSpeechRecognition' in window) ) {
    console.error("Webkit Speech Recogntion Not Supported")

    this.props.speechErrorHUD()
} else {


    recognition.lang = "en-US"
    // this.recognition.lang = "uk-UA"

    recognition.continuous = false
    recognition.interimResults = true

    recognition.onstart = () => store.dispatch(onstart())
    recognition.onresult = (e) => onresult(e)
    recognition.onerror = (e) => store.dispatch(onerror(e))
    recognition.onend = (e) => store.dispatch(onend(e))
    
    // recognition.onnomatch = () => onnomatch()

}

export const startSpeech = () => {
    
    let sphere = document.getElementById("small-sphere")
    sphere.emit("sphereopen")

    recognition.start()

    return {
        type: "SPEECH_START",
    }
}

export const stopSpeech = () => {

    return (dispatch) => {

        dispatch( setWorldState("WORLD_VIEW") )

        recognition.abort()

        return {
            type: "SPEECH_ABORT",
        }
    }
}

export const stopSpeechKeyboard = () => {
    
        return (dispatch) => {
            recognition.abort()
            return {
                type: "SPEECH_ABORT",
            }
        }
    }

export const abortSpeech = () => {

    let sphere = document.getElementById("small-sphere")
    sphere.emit("sphereclose")

    recognition.stop()

    return {
        type: "SPEECH_STOP",
    }
}



// WEBPACK FOOTER //
// ./src/actions/microphone.js